export default __webpack_public_path__ + "static/media/publicicon1.dc8fbb05.svg";